import React from 'react';
import Header from '../login/Header'; // ログインページのヘッダーを再利用
import Email from './Email';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import { useTitle } from '../../hooks/useTitle';

const PasswordForgot = () => {
  useTitle('Ton Bébé | パスワードをお忘れの方');

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="login">
          <h1 className="sec_title">パスワードをお忘れの方</h1>
          <div className="border_box">
            <Email />
            <section>
              <p>ログイン画面は<Link to="/login">こちら</Link></p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PasswordForgot;
